import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { AnalisesSpggProjeto } from '../../models/analises-spgg-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { AnalisesSpggProjetoService } from '../../services/analises-spgg-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-analises-spgg-list',
  templateUrl: './detalhe-projeto-analises-spgg-list.component.html',
  styleUrls: ['./detalhe-projeto-analises-spgg-list.component.scss']
})
export class DetalheProjetoAnalisesSpggListComponent extends BaseListComponent<AnalisesSpggProjeto> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  anteriores: boolean = false;
  dtOptions2: any = {};
  permission: any = {};
  analises: AnalisesSpggProjeto[]

  constructor(
    private myService: AnalisesSpggProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initLoadDataTable();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.getListAll(this.idProjeto).subscribe((res) => {
        this.analises = res['analises'];
        this.permission = res;
        this.loaded();
      })
    );
  }

  novaDemanda() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(id: number){
    return { pf_analysis_id: id } ;
  }

  mostrarAnteriores() {
    this.anteriores = !this.anteriores;
  }

  novo() {
    return ['/projetos', 'projeto', this.idProjeto, 'analises', 'spgg', 'adicionar'];
  }

  editarClickHandler(data: any) {
    return ['/projetos', 'projeto', this.idProjeto, 'analises', 'spgg', data.id];
  }

  confirmExcluir(item : any) {
    let id = item.id;
    if( !item.last_one ) {
      this.msgError("Apenas a última análise pode ser excluída ou editada.")
      return;
    }    

    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        if( error.error.message != undefined ) this.msgError(error.error.message)        
        this.loaded();
      }
    });
  }

  editar(id: number) {
    return ['/projetos', 'projeto', this.idProjeto, 'analises', 'spgg', id];
  }
}

